import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../api/client';

export function ImpersonationBanner() {
  const { user, reload } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  if (!user?.impersonatedBy) return null;

  async function handleExit() {
    setLoading(true);
    try {
      const result = await api.admin.exitImpersonation();
      if (result.expired) {
        window.location.href = '/auth/google';
      } else {
        await reload();
        navigate('/admin/users');
      }
    } catch {
      window.location.href = '/auth/google';
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center justify-center gap-4 bg-amber-400 px-4 py-2 text-sm font-medium text-amber-900">
      <span>
        Viewing as <strong>{user.email}</strong> (impersonation session)
      </span>
      <button
        onClick={handleExit}
        disabled={loading}
        className="rounded bg-amber-900 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-800 disabled:opacity-50"
      >
        {loading ? 'Returning...' : 'Return to admin'}
      </button>
    </div>
  );
}
